<template>
  <section class="gallery">
    <div class="gallery__wrapper">
      <masonry
        :cols="{default: 3, 768: 2}"
        :gutter="4"
      >
        <div class="gallery__item" v-for="i in countImages" :key="i">
          <img :src="`gallery/${i}.jpg`" onload="this.style.opacity = 1" />
        </div>
      </masonry>
    </div>
  </section>
</template>

<script>
  const COUNT_IMAGES = 58;

  export default {
    name: 'Gallery',
    data: () => ({
      options: {
        width: 300,
        padding: 4
      },
      countImages: 10,
      isLoading: true
    }),
    methods: {
      append () {
        this.countImages = this.countImages + 10 < COUNT_IMAGES ? this.countImages + 10 : COUNT_IMAGES
      },
      watchScroll () {
        const {
          scrollTop,
          clientHeight,
          scrollHeight
        } = document.documentElement

        if (scrollTop + clientHeight >= scrollHeight - 400) {
          this.append()
        }
      }
    },
    mounted () {
      window.addEventListener('scroll', this.watchScroll)
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.watchScroll)
    }
  }
</script>